const screensize = window.innerWidth;
export const isLVP = screensize > 820;
